import SelectedChips from './SelectedChips';

export default SelectedChips;
